export enum EmployeeRoleEnum {
  Accountant = 40,
  Admin = 90,
  Owner = 100,
}
